@if (dataLoaded) {
  <app-wizard-step-shell
    [title]="currentStep.titleKey"
    [steps]="steps"
    [currentStepIndex]="currentStepIndex"
    [maxReachedIndex]="maxReachedIndex"
    [isFirstStep]="isFirstStep"
    [isLastStep]="isLastStep"
    [nextDisabled]="nextDisabled"
    (backClicked)="back()"
    (nextClicked)="next()"
    (cancelClicked)="cancel()"
    (stepSelected)="goToStep($event)">

    @switch (currentStep.id) {
      @case ('name') {
        <app-name-step #stepRef [initialData]="nameStepData"></app-name-step>
      }
      @case ('address') {
        <app-address-step #stepRef [initialData]="addressStepData"></app-address-step>
      }
      @case ('email') {
        <app-email-step #stepRef [initialData]="emailStepData"></app-email-step>
      }
      @case ('school') {
        <app-school-step #stepRef [initialData]="schoolStepData"></app-school-step>
      }
      @case ('geschwister') {
        <app-geschwister-step #stepRef [ticketId]="ticket.id" [initialData]="geschwisterStepData"></app-geschwister-step>
      }
      @case ('payment') {
        <app-payment-step #stepRef [initialData]="paymentStepData"></app-payment-step>
      }
      @case ('summary') {
        <app-summary-step #stepRef [ticketId]="ticket.id" [visibleStepIds]="visibleStepIds"></app-summary-step>
      }
    }
  </app-wizard-step-shell>
}
